<template>
<div class="row my-4">
  <div class="col-auto" v-if="!allRowsProcessed && jobStatus !== 'CANCELED'">
    <button v-if="jobStatus === 'RUNNING' || jobStatus === 'PENDING'"
            class="btn btn-sm btn-primary"
            id="pause_job"
            :disabled="pauseBtnDisabled"
            @click="pauseJob">
      <i class="fa fa-pause"></i> {{ 'PAUSE' | translate }}
    </button>
    <button v-if="jobStatus !== 'RUNNING' && jobStatus !== 'PENDING'"
        class="btn btn-sm btn-primary"
        id="start_job"
        :disabled="canceling || (jobType === 'IMPORT_NVGA2' && !atLeastOneSelected)"
        @click="startJob">
        <i class="fa fa-play"></i> {{ 'START' | translate }}
    </button>
    <button v-if="jobStatus === 'PAUSED' && (jobType === 'IMPORT' || jobType === 'RECALC')"
            class="btn btn-sm btn-default ml-2"
            id="cancel_job"
            :disabled="canceling || pauseInProgress"
            @click="showConfirmForCancelAction = true">
      <i class="fa fa-times text-danger"></i> {{ 'CANCEL' | translate }}
    </button>
  </div>

  <div class="col">
    <div class="progress mt-1">
      <div class="progress-bar bg-success"
           role="progressbar"
           :style="'width: ' + completedPercent + '%;'"
           :aria-valuenow="completedPercent"
           aria-valuemin="0"
           aria-valuemax="100">
        <strong v-if="completedCount > 0">{{ completedCount }}</strong>
      </div>
      <div class="progress-bar bg-warning"
           role="progressbar"
           :style="'width: ' + skippedPercent + '%;'"
           :aria-valuenow="skippedPercent"
           aria-valuemin="0"
           aria-valuemax="100">
        <strong v-if="skippedCount > 0">{{ skippedCount }}</strong>
      </div>
      <div class="progress-bar bg-danger"
           role="progressbar"
           :style="'width: ' + errorPercent + '%;'"
           :aria-valuenow="errorPercent"
           aria-valuemin="0"
           aria-valuemax="100">
        <strong v-if="errorCount > 0">{{ errorCount }}</strong>
      </div>
    </div>
  </div>

  <confirm-dialog :show="showConfirmForCancelAction"
                  :textLabel="'msg.SURE_CANCEL_ACTION'"
                  @hide-dialog="showConfirmForCancelAction = false"
                  @confirm="cancelJob">
  </confirm-dialog>

</div>
</template>

<script>
import ConfirmDialog from '../dialog/ConfirmDialog';

export default {
  props: ['allRowsProcessed', 'jobType', 'jobStatus', 'completedPercent', 'completedCount', 'errorPercent', 'errorCount', 'pauseInProgress', 'canceling', 'skippedPercent', 'skippedCount', 'atLeastOneSelected'],
  components: { ConfirmDialog },
  data: function () {
    return {
      pauseBtnDisabled: false,
      showConfirmForCancelAction: false
    }
  },
  methods: {
    pauseJob() {
      this.pauseBtnDisabled = true;
      this.$emit('pause-job');
    },
    startJob() {
      this.pauseBtnDisabled = false;
      this.$emit('start-job');
    },
    cancelJob() {
      this.showConfirmForCancelAction = false;
      this.$emit('cancel-job');
    }
  }
}
</script>

<style scoped>
  .progress {
    height: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/components/job/JobDetailsProgress.vue